import { ScrollCaptain } from 'scroll-captain';
import './tile-teaser.scss';

class TileTeaser {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-tileteaser',
            tileValue: 'tile',
            breakpoint: 1023
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);
        
        // DOM Elements
        this.$root = element;
        this.$$tiles = this.$root.querySelectorAll(`[${this.settings.initAttr}^="${this.settings.tileValue}"]`);

        // Options
        this.animation = null;
        this.breakpoint = window.matchMedia(`(max-width: ${this.settings.breakpoint}px)`);
        this.breakpointActive = this.breakpoint.matches;
        this.multiplier = window.reducedMotionActive ? 0 : 1;
    }

    initialize () { 
        this.loadAnimation();
        this.setEvents();
    }

    // Configure and load animations with ScrollCaptain
    loadAnimation () {
        let animationOptions = {
            initAttr: this.settings.initAttr,
            updateOnResize: () => {
                if (this.breakpoint.matches !== this.breakpointActive) {
                    this.breakpointActive = this.breakpoint.matches;
                    this.updateAnimation(false);
                }
            }
        };

        // Set up individual animations for each tile
        this.$$tiles.forEach(($tile, index) => {
            const key = `animateTile${index + 1}`;            

            animationOptions[key] = {
                targetSuffix: `${this.settings.tileValue}-${index + 1}`,
                onscroll: true,
                translateX: this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 }
            };
        });        

        this.animation = new ScrollCaptain(this.$root, animationOptions);        
    }

    updateAnimation (updateRequired) {        
        // Set up individual animations for each tile
        this.$$tiles.forEach(($tile, index) => {
            const key = `animateTile${index + 1}`;        
            this.animation.defaultOptions[key].translateX = this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 };
        });

        if (updateRequired) {
            this.animation.update();
        }
    }

    setEvents () {
        window.addEventListener('motionPreferenceChanged', () => {
            this.multiplier = window.reducedMotionActive ? 0 : 1;
            this.updateAnimation(true);
        });
    }
}

export { TileTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-tileteaser="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new TileTeaser($root);
            $rootAPI.initialize();
        });
    }
});
